<template>
    <div class="t-lk-events">
        <div class="t-lk-container">
            <lk-breadcrumbs-cmp :breadcrumbs="breadcrumbs"></lk-breadcrumbs-cmp>
            <h1 class="t-lk-title t-lk-promotions__title t-lk-container-mobile">
                {{ $root.staticText.lk.photoTitle }}
            </h1>
            <div class="t-lk-events-photos js-photos">
                <lk-photos-item-cmp
                    v-animation:bottom.delay
                    v-for="(item, index) in photos"
                    :item="item"
                    :key="'photos-item' + index"
                >
                </lk-photos-item-cmp>
            </div>
            <load-more-cmp
                v-if="pagination"
                :pagination="pagination"
                :btn="$root.staticText.lk.loadMore"
                class="t-faq__more"
                :disabled-btn="disableLoadMore"
            >
            </load-more-cmp>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import lkBreadcrumbs from '@components/lk/lk-breadcrumbs/lk-breadcrumbs.vue';
    import photosItem from '@components/lk/lk-photos-item/lk-photos-item.vue';
    import LoadMore from '@components/ui-components/load-more/load-more';
    import {router} from "@src/routes";

    export default {
        name: "lk-events-photos",
        data() {
            return {
                breadcrumbs: null,
                photos: [],
                pagination: null,
                disableLoadMore: false,
            }
        },
        components: {
            'lk-breadcrumbs-cmp': lkBreadcrumbs,
            'lk-photos-item-cmp': photosItem,
            'load-more-cmp': LoadMore,
        },
        methods: {
            setData(data) {
                this.breadcrumbs = data.breadcrumbs;
                this.photos = data.photos;
                this.pagination = data.pagination;
            },
        },
        beforeRouteUpdate(to, from, next) {
            this.disableLoadMore = true;
            let url = process.env.NODE_ENV !== 'production' ?
                'lk/photosPage.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    next();
                    this.photos = this.photos.concat(data.data.photos);
                    this.pagination = data.data.pagination;
                    this.disableLoadMore = false;
                },
                (data) => {
                    this.disableLoadMore = false;
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        },
        beforeRouteEnter(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ?
                'lk/photosPage.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    next(vm => vm.setData(data.data));
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/events/photos/index.vue